import React from 'react'

import ListItemAvatar from '@mui/material/ListItemAvatar'

import { CategoryIcon } from '@mxenabled/mxui'

import { SingleSegmentDonut } from '../../../common'

interface BudgetDonutProps {
  background: string
  percentage: number
  categoryGuid?: string
}

export const BudgetDonut: React.FC<BudgetDonutProps> = ({
  background,
  percentage,
  categoryGuid,
}) => {
  return (
    <ListItemAvatar sx={{ mb: -8, mr: 16 }}>
      <SingleSegmentDonut color={background} percent={percentage} size={40}>
        {categoryGuid && <CategoryIcon categoryGuid={categoryGuid} variant="basic" />}
      </SingleSegmentDonut>
    </ListItemAvatar>
  )
}
